/**
 * 初始化PE数据及方法 （每打开一个新页签都需要重新初始化！！！）
 * @param {Object} data
 * nodeName 应用菜单名
 * nodeCode 应用编码
 * userID 用户编码 由于需要知道具体哪个人所以取 userCode 的值！ 此处需要注意
 * projectCode 项目编码
 * nlinkUrl pe 地址
 */
const PEDataController = lessData => data => {
    window.peData = { ...lessData, ...data };
    let $NCPE = require("Pub/js/pe");
    // 初始化pe
    window.proxyAction = $NCPE.default.proxyAction;
    window.startAjax = $NCPE.default.startAjax;
    window.endAjax = $NCPE.default.endAjax;
};
export default PEDataController;
